import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { CurrentStepSetAction } from "../actions/action";

import PageHeader from "../components/header/header";
import PageFooter from "../components/footer/footer";
import Breadcrumb from "../components/Breadcrumb/Breadcrumb";
import CONSTANTS from "../constants";
import SearchArea from "../components/search-area/search-area";

const mapStateToProps = (state) => state;
const mapDispatchToProps = { CurrentStepSetAction };

class Layout extends Component {
  static defaultProps = {
    BreadcrumbIsEnabled: true,
  };
  constructor(props) {
    super(props);
  }
  render() {
    const ActivatePaP = !!parseInt(
      CONSTANTS.SITE_INFO.ACTIVATENEWAPPOINTMENTJOURNEY
    );

    const happyHoureMessage =
      window.innerWidth <= 800
        ? CONSTANTS.LABELS.multislots_happy_hours_mobile
        : CONSTANTS.LABELS.multislots_happy_hours_desktop;
    const isHappuHoureMessageEnabled =
      happyHoureMessage.length > 2 ? true : false;

    return (
      <>
        <PageHeader />
        <div className="page-content">
          {this.props.BreadcrumbIsEnabled && ActivatePaP && <Breadcrumb />}
          {/* 
                La parie recherche est rajouté dans "Layout" seulement pour la marque DS et Citroen
                à cause du changement de positionnement entre le file d'ariane et la barre de recherche
                (Les autres marques la partie recherche est dans le "Header" qui est d'ailleur caché pour DS) 
              */}

          {CONSTANTS.SITE_INFO.BRAND_CODE === "C" && (
            <p
              className="title-recherche-atelier"
              dangerouslySetInnerHTML={{
                __html:
                  this.props.store.step === 1
                    ? CONSTANTS.LABELS.dealer_locator_title2
                    : CONSTANTS.LABELS.multislots_select_slot,
              }}
            ></p>
          )}

          {CONSTANTS.SITE_INFO.BRAND_CODE === "C" && (
            <p
              className="subTitle-zoom-map"
              dangerouslySetInnerHTML={{
                __html:
                  this.props.store.step === 1
                    ? CONSTANTS.LABELS.dealer_locator_maptitle
                    : isHappuHoureMessageEnabled
                    ? happyHoureMessage
                    : "",
              }}
            ></p>
          )}

          {CONSTANTS.SITE_INFO.BRAND_CODE === "C" &&
            this.props.store.step === 1 && (
              <p
                className="subTitle-zoom-map"
                dangerouslySetInnerHTML={{
                  __html: CONSTANTS.LABELS.dealer_locator_subtitle,
                }}
              ></p>
            )}

          {(window.siteConfig.currentBrand == "D" ||
            window.siteConfig.currentBrand == "C") &&
            !this.props.store.isEditMode && <SearchArea />}
          {this.props.children}
        </div>
        <PageFooter props={this.props} />
      </>
    );
  }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Layout));
